<!-- 我的海报卡片 -->
<template>
  <div class="van-hairline--bottom poster-view" @click="edit(item)">
    <van-image class="poster-icon" width="110px" height="110px" radius="10" fit="cover" :src="item.img" />
    <div class="poster-desc-view">
      <div class="van-multi-ellipsis--l2 poster-title">{{item.name}}</div>
      <div class="poster-sub-text">浏览量：{{item.pv}}次</div>
      <div class="poster-select" @click.stop="" @click="share" v-if="$store.state.user.from != 'miniApp'">分享</div>
      <div class="iconfont poster-menu" @click.stop="" @click="clickOverlay">&#xe693;</div>
    </div>
    <transition name="van-fade">
      <div class="poster-overlay" v-show="show" @click="show=false" @click.stop=""></div>
    </transition>
    <div class="poster-menu-view" v-show="show" @click.stop="">
      <div class="van-hairline--bottom poster-menu-update-title" @click="showDialog = true">修改标题</div>
      <div class="poster-menu-delete" @click="delelete">删除</div>
    </div>
    <div @click.stop="">
      <van-dialog v-model="showDialog" title="重命名" show-cancel-button @confirm="reNameConfirm" @click.stop="">
        <div class="poster-field" @click.stop="">
          <van-field v-model="reName" placeholder="请输入海报名称"/>
        </div>
      </van-dialog>
      <postershare ref="postershare" :title="item.name" :canvasImg="item.img"></postershare>
    </div>    
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import postershare from './posterShare.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  name: 'postercard',
  components: {
    postershare
  },
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data () {
    // 这里存放数据
    return {
      show: false,
      showDialog: false,
      reName: '',
      deleteStatus: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    clickOverlay() {
      this.show = true;
    },
    // 重命名
    reNameConfirm() {
      this.show = false;
      var params = {
        id: this.item.id,
        name: this.reName
      }
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.$http.updatePoster(params).then(res => {
        var data = res.data;
        this.item.name = this.reName;
        this.$Toast.success('更新成功');
      }).catch(error => {
        // Dialog({ message: error.data.message });
         this.$Toast.clear();
      })
    },
    delelete() {
      var params = {
        id: this.item.id
      }
      this.$http.delPoster(params).then(res => {
        var data = res.data;
        this.$emit('deleteItem', this.item.id);
      }).catch(error => {
        // Dialog({ message: error.data.message });
      })
    },
    edit(item) {
      item.template = item.content
      console.log(item);
      window.I.$RangersEvent('myPosterEditPage_editBtn_click')
      this.$router.push({
        name: 'edit',
        query: {item: JSON.stringify(item)}
      })
    },
    share() {
      window.I.$RangersEvent('myPosterEditPage_saveBtn_click')
      this.$refs.postershare.setShow(true, this.item.id);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less">
.poster-field {
  padding: 30px;
}
.poster-overlay {
  background-color: rgba(0, 0, 0, .2);
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.poster-menu-view {
  position: absolute;
  bottom: 30px;
  right: 44px;
  background-color: #FFFFFF;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
}
.poster-menu-update-title {
  font-size: 14px;
  padding: 5px 15px;
  color: #424242;
  text-align: center;
}
.poster-menu-delete {
  font-size: 14px;
  padding: 5px 15px;
  color: rgb(249, 71, 71);
  text-align: center;
}
.poster-view {
  height: 145px;
  background: #FFFFFF;
  padding: 15px;
  display: flex;
  position: relative;
}
.poster-icon {
  margin-right: 20px;
  width: 110px;
  height: 110px;
  background: #C9CED6;
  border-radius: 10px;
}
.poster-desc-view {
  flex: 1;
  position: relative;
}
.poster-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
}
.poster-menu {
  height: 24.5px;
  line-height: 24.5px;
  font-size: 8px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #8a8a8a;
  position: absolute;
  bottom: 0px;
  right: 17px;
}
.poster-select {
  height: 24.5px;
  line-height: 24.5px;
  background: #4B5173;
  border-radius: 25px;
  padding: 0px 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  position: absolute;
  bottom: 0px;
  right: 66px;
}
.poster-sub-text {
  margin-top: 5px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
</style>
